import { useQuery } from '@tanstack/react-query';

import { getCategories } from 'api';
import { AxiosRequestConfig } from 'axios';

/**
 * A custom hook for watchlist
 *
 * @returns DefinedUseQueryResult<Course[], Error>
 */
export const useCategoriesQuery = (config?: AxiosRequestConfig) => {
  // const queryClient = useQueryClient();
  // const [enableQuery, setEnableQuery] = React.useState(true);

  const query = useQuery({
    queryKey: ['categories'],
    // enabled: enableQuery,
    queryFn: () => {
      return getCategories(config);
    },
    initialData: []
  });

  return { query } as const;
};
